import React, { useState } from "react";
import JisDialogForm from "../../components/formdialog";
import JisButton from "../../components/controls/jisButton";
import * as Constants from "../../constants";

const personName = (p, fallbackSuffix = "") =>
  p ? `${p.suffix || fallbackSuffix} ${p.firstName || ""} ${p.lastName || ""}`.trim() : "N/A";

function RelatedCasesModal({
  relatedCasesData,
  onClose,
  onRemoveCases,
  selectedCases,
  frequentData,
}) {
  const [expandedSections, setExpandedSections] = useState(new Set());
  const [showTooltip, setShowTooltip] = useState(() => {
    const clickCount = sessionStorage.getItem("relatedCasesClickCount");
    return !clickCount || parseInt(clickCount) < 2;
  });

  const toggleSection = (caseId) => {
    const newExpanded = new Set(expandedSections);
    if (newExpanded.has(caseId)) {
      newExpanded.delete(caseId);
    } else {
      newExpanded.add(caseId);
    }
    setExpandedSections(newExpanded);

    // Increment click count and hide tooltip after 2 clicks
    if (showTooltip) {
      const currentCount = parseInt(
        sessionStorage.getItem("relatedCasesClickCount") || "0"
      );
      const newCount = currentCount + 1;
      sessionStorage.setItem("relatedCasesClickCount", newCount.toString());

      if (newCount >= 2) {
        setShowTooltip(false);
      }
    }
  };

  const handleOk = () => {
    // Get all case IDs that have related cases
    const caseIdsToRemove = relatedCasesData
      .filter((caseGroup) => caseGroup.data?.results?.length > 0)
      .map((caseGroup) => caseGroup.caseId);

    onRemoveCases(caseIdsToRemove);
  };

  const handleCancel = () => {
    onClose();
  };

  console.log(selectedCases, "test modal");

  return (
    <JisDialogForm title="Related Cases" onClose={handleCancel}>
      <div style={{ position: "relative" }}>
        {/* Scrollable content area */}
        <div
          style={{
            maxHeight: "60vh",
            overflowY: "auto",
            maxWidth: "90vw",
            // paddingBottom: "20px",
          }}
        >
          {relatedCasesData.map((caseGroup, groupIndex) => {
            const isExpanded = expandedSections.has(caseGroup.caseId);
            const hasResults = caseGroup.data?.results?.length > 0;
            console.log(caseGroup);
            return (
              <div
                key={groupIndex}
                style={{
                  // marginBottom: "20px",
                  border: "1px solid #ddd",
                  borderRadius: "5px",
                  position: "relative",
                }}
              >
                <div
                  onClick={() => toggleSection(caseGroup.caseId)}
                  className={`related-case-table-header ${
                    isExpanded ? "expanded" : ""
                  }`}
                  style={{ position: "relative" }}
                >
                  <div>
                    <p style={{ fontWeight: "bold" }}>
                      Case Number:{" "}
                      {selectedCases[caseGroup.caseId]?.caseNumber ||
                        caseGroup.caseId}
                      {hasResults &&
                        ` (${caseGroup.data.results.length} related cases)`}
                    </p>
                    <p style={{ fontWeight: "bold", marginTop: 4 }}>
                      Case Title:{" "}
                      {selectedCases[caseGroup.caseId]?.caseTitle ||
                        caseGroup.caseId}
                      {hasResults &&
                        ` (${caseGroup.data.results.length} related cases)`}
                    </p>
                  </div>
                  {/* <span style={{ fontSize: "20px" }}>
                    {isExpanded ? "−" : "+"}
                  </span> */}

                  <div>
                    <svg
                      width={24}
                      height={24}
                      viewBox="0 0 24 24"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M11.9995 16.8006C11.2995 16.8006 10.5995 16.5306 10.0695 16.0006L3.54953 9.48062C3.25953 9.19062 3.25953 8.71062 3.54953 8.42063C3.83953 8.13063 4.31953 8.13063 4.60953 8.42063L11.1295 14.9406C11.6095 15.4206 12.3895 15.4206 12.8695 14.9406L19.3895 8.42063C19.6795 8.13063 20.1595 8.13063 20.4495 8.42063C20.7395 8.71062 20.7395 9.19062 20.4495 9.48062L13.9295 16.0006C13.3995 16.5306 12.6995 16.8006 11.9995 16.8006Z"
                        fill="white"
                      />
                    </svg>

                    {/* Tooltip indicator */}
                    {showTooltip && (
                      <div
                        style={{
                          position: "absolute",
                          top: "25%",
                          right: "4%",
                          transform: "translateY(-50%)",
                          padding: "8px 12px",
                          backgroundColor: "#2196F3",
                          color: "white",
                          borderRadius: "6px",
                          fontSize: "13px",
                          whiteSpace: "nowrap",
                          boxShadow: "0 2px 8px rgba(0,0,0,0.15)",
                          zIndex: 1000,
                          animation: "pulse 1.5s ease-in-out infinite",
                        }}
                      >
                        Click here to view
                        {/* Arrow pointing right to the chevron */}
                        <div
                          style={{
                            position: "absolute",
                            top: "50%",
                            left: "100%",
                            transform: "translateY(-50%)",
                            width: 0,
                            height: 0,
                            borderTop: "6px solid transparent",
                            borderBottom: "6px solid transparent",
                            borderLeft: "6px solid #2196F3",
                          }}
                        />
                      </div>
                    )}
                  </div>
                </div>

                {isExpanded && (
                  <div className="table">
                    {hasResults ? (
                      <>
                        <div className="table-wrapper">
                          <table className="case-table">
                            <thead>
                              <tr>
                                <th className="col-title">Suit Number</th>
                                <th className="col-title">Party Name</th>
                                <th className="col-title">Case Title</th>
                                <th className="col-title">Legal Counsel</th>
                                <th className="col-medium">Assigned Judge</th>
                              </tr>
                            </thead>
                            <tbody>
                              {caseGroup.data.results.map(
                                (relatedCase, index) => (
                                  <tr key={index}>
                                    <td>{relatedCase.caseNumber || "N/A"}</td>
                                    <td>
                                      {relatedCase.parties?.length > 0
                                        ? relatedCase.parties.map((p) => (
                                            <div key={p.partyId}>{p.name}</div>
                                          ))
                                        : relatedCase.party
                                          ? `${relatedCase.party.partyFirstName || ""} ${relatedCase.party.partyLastName || ""}`.trim()
                                          : "N/A"}
                                    </td>
                                    <td>{relatedCase.caseTitle}</td>
                                    <td>{personName(relatedCase.legalCounsel)}</td>
                                    <td>{personName(relatedCase.judge, "Hon. Justice")}</td>
                                  </tr>
                                )
                              )}
                            </tbody>
                          </table>
                        </div>

                        {/* {caseGroup.data.keywords?.length > 0 && (
                          <div
                            style={{
                              marginTop: "10px",
                              padding: "10px",
                              backgroundColor: "#f9f9f9",
                              borderRadius: "5px",
                            }}
                          >
                            <strong>Keywords: </strong>
                            {caseGroup.data.keywords.join(", ")}
                          </div>
                        )} */}
                      </>
                    ) : (
                      <div
                        style={{
                          padding: "20px",
                          textAlign: "center",
                          color: "#666",
                        }}
                      >
                        No related cases found for Case Number:{" "}
                        {selectedCases[caseGroup.caseId]?.caseNumber ||
                          caseGroup.caseId}
                      </div>
                    )}
                  </div>
                )}
              </div>
            );
          })}
        </div>

        {/* Fixed instruction and buttons at bottom of modal */}
        <div style={{ maxWidth: "90vw" }} className="related-case-modal-footer">
          <p
            style={{
              fontWeight: 500,
              fontSize: 16,
              color: "#000000",
            }}
          >
            Click OK to continue the assignment, or Cancel to return to the
            Pending tab
          </p>
          <div className="related-case-modal-btn-container">
            <button
              onClick={handleOk}
              className="related-case-modal-btn-outline"
            >
              Cancel
            </button>
            <button
              onClick={handleCancel}
              className="related-case-modal-btn-solid"
            >
              OK
            </button>
          </div>
        </div>
      </div>

      {/* CSS for pulse animation */}
      <style>{`
        @keyframes pulse {
          0%, 100% {
            transform: scale(1);
            opacity: 1;
          }
          50% {
            transform: scale(1.05);
            opacity: 0.9;
          }
        }
      `}</style>
    </JisDialogForm>
  );
}

export default RelatedCasesModal;
